import React from "react";
import Faqs from "../elements/Faqs";
import Banner from "../elements/Banner";
import PromotionSlider from "../elements/PromotionSlider";
import BottomBanner from "../elements/BottomBanner";

export default function FAQ(props) {
  return (
    <>
      <Banner pageName="promotions" {...props} />
     
      <Faqs {...props} />
      <PromotionSlider {...props} />
      <BottomBanner {...props} />
    </>
  );
}
